import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import VoiceRecorder from './components/VoiceRecorder';
import DiscoverProfiles from './components/DiscoverProfiles';
import MatchesList from './components/MatchesList';
import ChatView from './components/ChatView';
import PaymentPage from './components/PaymentPage';
import { Toaster } from './components/ui/sonner';
import { useAuth } from './hooks/useAuth';

function App() {
  const { user, loading, handleLogout, fetchUserProfile } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-pink-50 via-white to-purple-50">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-pink-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <>
        <Login />
        <Toaster position="top-center" richColors />
      </>
    );
  }

  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<Dashboard user={user} onLogout={handleLogout} onProfileUpdate={fetchUserProfile} />} />
          <Route path="/record-voice" element={<VoiceRecorder user={user} onComplete={fetchUserProfile} />} />
          <Route path="/discover" element={<DiscoverProfiles user={user} />} />
          <Route path="/matches" element={<MatchesList user={user} />} />
          <Route path="/chat/:matchId" element={<ChatView user={user} />} />
          <Route path="/upgrade" element={<PaymentPage user={user} />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </div>
    </BrowserRouter>
  );
}

export default App;
